module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-48.c66d87ab.png";